import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

/**
 * Component that ensures enhanced error tracking is properly initialized
 * when PostHog is available. This should be rendered once in the app.
 */
export const ErrorTrackingInitializer = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      console.log("🔍 Enhanced error tracking initialized with PostHog");

      // The global error handlers are already set up in posthog.ts
      // when PostHog loads, but we can verify they're working here

      // Send a test event to verify error tracking is working
      if (import.meta.env.DEV) {
        posthog.capture("error_tracking_initialized", {
          timestamp: new Date().toISOString(),
          environment: import.meta.env.MODE,
        });
      }
    }
  }, [posthog]);

  // This component doesn't render anything
  return null;
};
